/* ============================================================================
   LAH WISHLIST — sistema de favoritos (Rota C)
   Tema: Claude (custom 0.2)

   Camada de dados por localStorage, namespaced por customer.id. Como o
   requisito é "só salva se estiver logado", nada é gravado se
   window.LAH_CUSTOMER_ID for null — o clique redireciona para o login.

   Arquitetura pensada para trocar de camada de dados no futuro (app de
   wishlist ou backend próprio): toda leitura/escrita passa pelas funções
   getItems/saveItems/addItem/removeItem abaixo — no dia da migração, só
   essas 4 funções precisam mudar (para chamadas de API), o resto (UI,
   render, eventos) continua igual.
   ============================================================================ */

(function () {
    'use strict';

    var STORAGE_PREFIX = 'lah_wishlist_';

    /* ------------------------------------------------------------------
       Camada de dados (troque aqui no dia de migrar para app/backend)
       ------------------------------------------------------------------ */
    function storageKey() {
        var customerId = window.LAH_CUSTOMER_ID;
        return customerId ? (STORAGE_PREFIX + customerId) : null;
    }

    function getItems() {
        var key = storageKey();
        if (!key) return [];
        try {
            var raw = localStorage.getItem(key);
            return raw ? JSON.parse(raw) : [];
        } catch (e) {
            return [];
        }
    }

    function saveItems(items) {
        var key = storageKey();
        if (!key) return;
        try {
            localStorage.setItem(key, JSON.stringify(items));
        } catch (e) {}
    }

    function isFavorited(variantId) {
        return getItems().some(function (i) { return String(i.variantId) === String(variantId); });
    }

    function addItem(item) {
        var items = getItems();
        if (items.some(function (i) { return String(i.variantId) === String(item.variantId); })) return;
        items.unshift(item);
        saveItems(items);
    }

    function removeItem(variantId) {
        var items = getItems().filter(function (i) { return String(i.variantId) !== String(variantId); });
        saveItems(items);
    }

    /* ------------------------------------------------------------------
       Login gate
       ------------------------------------------------------------------ */
    function requireLogin() {
        var returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
        var loginUrl = window.LAH_LOGIN_URL || '/account/login';
        window.location.href = loginUrl + (loginUrl.indexOf('?') > -1 ? '&' : '?') + 'return_url=' + returnUrl;
    }

    /* ------------------------------------------------------------------
       Badge do cabeçalho
       ------------------------------------------------------------------ */
    function updateBadges() {
        var count = window.LAH_CUSTOMER_ID ? getItems().length : 0;
        document.querySelectorAll('.lah-wishlist-count').forEach(function (el) {
            el.textContent = count;
            el.classList.toggle('is-visible', count > 0);
        });
    }

    /* ------------------------------------------------------------------
       Gaveta de favoritos
       ------------------------------------------------------------------ */
    function renderDrawer() {
        var list = document.querySelector('[data-lah-wishlist-list]');
        if (!list) return;

        if (!window.LAH_CUSTOMER_ID) {
            list.innerHTML =
                '<div class="lah-wishlist-login-prompt">' +
                    'Faça login para ver e salvar seus favoritos.<br>' +
                    '<a href="' + (window.LAH_LOGIN_URL || '/account/login') + '">Entrar na minha conta</a>' +
                '</div>';
            return;
        }

        var items = getItems();

        if (!items.length) {
            list.innerHTML = '<div class="lah-wishlist-empty">Sua lista de favoritos está vazia.</div>';
            return;
        }

        list.innerHTML = items.map(function (item) {
            return '' +
                '<div class="lah-wishlist-item">' +
                    '<a href="' + item.url + '">' +
                        '<img class="lah-wishlist-item__image" src="' + item.image + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' +
                    '</a>' +
                    '<div class="lah-wishlist-item__info">' +
                        '<a class="lah-wishlist-item__title" href="' + item.url + '">' + escapeHtml(item.title) + '</a>' +
                        '<span class="lah-wishlist-item__color">' + escapeHtml(item.color || '') + '</span>' +
                        (item.price ? '<span class="lah-wishlist-item__price">' + escapeHtml(item.price) + '</span>' : '') +
                    '</div>' +
                    '<button type="button" class="lah-wishlist-item__remove" data-lah-remove="' + item.variantId + '" aria-label="Remover dos favoritos">&times;</button>' +
                '</div>';
        }).join('');
    }

    function escapeHtml(str) {
        var div = document.createElement('div');
        div.textContent = str == null ? '' : String(str);
        return div.innerHTML;
    }

    function openDrawer() {
        var drawer = document.getElementById('lah-wishlist-drawer');
        if (!drawer) return;
        renderDrawer();
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('lah-wishlist-drawer-open');
        document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
        var drawer = document.getElementById('lah-wishlist-drawer');
        if (!drawer) return;
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('lah-wishlist-drawer-open');
        document.body.style.overflow = '';
    }

    /* ------------------------------------------------------------------
       Coração na página de produto
       ------------------------------------------------------------------ */
    function currentVariantId() {
        var btn = document.querySelector('.auglio-tryon-btn-product-page');
        return btn ? btn.getAttribute('data-item_id') : null;
    }

    function variantMap() {
        var el = document.getElementById('lah-wishlist-variant-map');
        if (!el) return {};
        try {
            return JSON.parse(el.textContent);
        } catch (e) {
            return {};
        }
    }

    function syncProductHearts() {
        var vid = currentVariantId();
        var favorited = vid && window.LAH_CUSTOMER_ID ? isFavorited(vid) : false;
        document.querySelectorAll('.lah-heart-btn').forEach(function (btn) {
            btn.classList.toggle('is-favorited', favorited);
        });
    }

    function toggleProductFavorite() {
        if (!window.LAH_CUSTOMER_ID) {
            requireLogin();
            return;
        }

        var vid = currentVariantId();
        if (!vid) return;

        if (isFavorited(vid)) {
            removeItem(vid);
        } else {
            var map = variantMap();
            var data = map[vid];
            if (!data) return;
            addItem({
                variantId: vid,
                title: data.title,
                color: data.color,
                image: data.image,
                price: data.price,
                url: data.url
            });
        }

        syncProductHearts();
        updateBadges();
    }

    /* ------------------------------------------------------------------
       Eventos (delegação única no documento)
       ------------------------------------------------------------------ */
    document.addEventListener('click', function (event) {
        var target = event.target;

        var wishlistToggle = target.closest ? target.closest('.lah-wishlist-toggle') : null;
        if (wishlistToggle) {
            event.preventDefault();
            openDrawer();
            return;
        }

        var closeEl = target.closest ? target.closest('[data-lah-wishlist-close]') : null;
        if (closeEl) {
            event.preventDefault();
            closeDrawer();
            return;
        }

        var removeEl = target.closest ? target.closest('[data-lah-remove]') : null;
        if (removeEl) {
            event.preventDefault();
            removeItem(removeEl.getAttribute('data-lah-remove'));
            renderDrawer();
            updateBadges();
            syncProductHearts();
            return;
        }

        var heartBtn = target.closest ? target.closest('.lah-heart-btn') : null;
        if (heartBtn) {
            event.preventDefault();
            toggleProductFavorite();
            return;
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeDrawer();
    });

    /* Reage a troca de cor no seletor: mesma técnica já usada no toggle
       Grau/Sol — observa data-item_id do botão da Auglio, que o tema já
       mantém sincronizado com a variante selecionada. */
    function watchVariantChanges() {
        var btn = document.querySelector('.auglio-tryon-btn-product-page');
        if (!btn || !window.MutationObserver) return;
        if (btn.getAttribute('data-lah-wishlist-watched') === '1') return;
        btn.setAttribute('data-lah-wishlist-watched', '1');

        var observer = new MutationObserver(syncProductHearts);
        observer.observe(btn, { attributes: true, attributeFilter: ['data-item_id'] });
    }

    function boot() {
        updateBadges();
        syncProductHearts();
        watchVariantChanges();

        var ticks = 0;
        var timer = setInterval(function () {
            ticks++;
            syncProductHearts();
            watchVariantChanges();
            if (ticks >= 15) clearInterval(timer);
        }, 1000);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
})();
/* LAH WISHLIST — fim */
